import { ReactNode } from "react";
import useNavigationManager from "shared/hooks/useNavigationManager";

export default (props: { children: ReactNode }) => {
	useNavigationManager();

	return <>{props.children}</>;
};
